import { axiosSarlaft } from "@/plugins/axios";
import type { AxiosResponse } from "axios";

export const countryService = {
  getAll: async (): Promise<any> => {
    try {
      const response = await axiosSarlaft.get(`/paises`, {});
      const data = await response.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
  getDepartmentsByCountry: async (id: string): Promise<any> => {
    // const key = String(id);

    // Revisar si está en cache
    // if (fileService.cache.has(key)) {
    //   return fileService.cache.get(key);
    // }

    // Si no está, pedir al backend
    const response: AxiosResponse<any, any> = await axiosSarlaft.get(
      `/paises/${id}`
    );
    const data = response.data;

    // Guardar en cache para próximas llamadas
    // fileService.cache.set(key, data);

    return data;
  },
};
